<template>
  <div class="inquiry_term">
    <div class="inquiry_box">
      <div class="inquiry_cate">
        <el-icon class="el-icon-document-copy"></el-icon> 保险产品
      </div>
      <div class="inquiry_term_one" v-for="(item,index) in products" :key="index" @click="showProduct(item)">
        <el-card :body-style="{ padding: '0px' }" >
          <div class="inquiry_term_one_box">
            <div class="inquiry_term_title">
              {{ item.title }}
            </div>
            <div class="inquiry_term_special" v-if="item.special_list" v-for="(it,idx) in item.special_list.split(',')" :key="idx" v-html="it"></div>
            <div class="inquiry_term_grey">
              <div class="inquiry_term_grey_left">
                <div class="inquiry_term_grey_left_amount">
                  {{ item.premium_amount }}
                </div>
                <div class="inquiry_term_grey_left_amount_title">
                  总保额
                </div>
              </div>
              <div class="inquiry_term_grey_right">
                <div class="inquiry_term_grey_right_premium">
                  <span class="inquiry_term_grey_right_point">·</span> <span class="inquiry_term_grey_right_span">保费区间</span> {{ item.premium_range }}
                </div>
                <div class="inquiry_term_grey_right_rate">
                  <span class="inquiry_term_grey_right_point">·</span> <span class="inquiry_term_grey_right_span">费率区间</span> {{ item.rate_range }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :title="product.title"
      :visible.sync="dialogVisible" fullscreen>
      <h3 v-if="product.main_terms && product.main_terms.length>0">主险</h3>
      <p v-if="product.main_terms && product.main_terms.length>0" v-for="mitem in product.main_terms" :key="mitem.id">
        <span class="inquiry_term_detail_main" @click="showDetail('main',mitem.id)">《{{ mitem.title }}》</span>
      </p>
      <h3 v-if="product.additional_terms && product.additional_terms.length>0">附加险</h3>
      <p v-if="product.additional_terms && product.additional_terms.length>0" v-for="aitem in product.additional_terms" :key="aitem.id">
        <span class="inquiry_term_detail_additional" @click="showDetail('additional',aitem.id)">《{{ aitem.title }}》</span>
      </p>
      <h3 v-if="product.special_terms && product.special_terms.length>0">特别约定</h3>
      <p v-if="product.special_terms && product.special_terms.length>0" v-for="sitem in product.special_terms" :key="sitem.id">
        按照 <span class="inquiry_term_detail_special" @click="showDetail('special',sitem.id)">《{{ sitem.title }}》</span> {{ sitem.suffix }}
      </p>
      <h3 v-if="product.deductible_terms && product.deductible_terms.length>0">免赔条款</h3>
      <p v-if="product.deductible_terms && product.deductible_terms.length>0" v-for="ditem in product.deductible_terms" :key="ditem.id">
        <span class="inquiry_term_detail_special" @click="showDetail('deductible',ditem.id)">《{{ ditem.title }}》</span>
      </p>
      <h3>产品详情</h3>
      <div v-html="product.content"></div>
      <span slot="footer" class="dialog-footer">
        <p>
          <el-button @click="dialogVisible = false">关闭返回</el-button>
          <el-button type="danger" @click="toTerms(product.id)">立即询报价</el-button>
        </p>
        <p>&nbsp;</p>
      </span>
    </el-dialog>
    <el-dialog
      :title="dtypes[dtype]"
      :visible.sync="detailDialogVisible" fullscreen>
      <h3>《{{ detail.title }}》</h3>
      <div v-html="detail.content"></div>
      <span slot="footer" class="dialog-footer">
        <p>
          <el-button @click="detailDialogVisible = false">关 闭</el-button>
        </p>
        <p>&nbsp;</p>
      </span>
    </el-dialog>
    <div class="inquiry_bottom">
      <InquiryFooter/>
    </div>
  </div>
</template>

<script>
  import { getInsuranceProductsAll,getInsuranceProductsById,insuranceMainTermsById,insuranceAdditionalTermsById,insuranceSpecialTermsById,insuranceDeductibleTermsById } from '../../api/api'
  import InquiryFooter from './footer'

  export default {
    name: "InquiryIndex",
    components: {
      InquiryFooter
    },
    data() {
      return {
        pid:this.$route.query.id,
        products:[],
        product:{},
        productInfo:{},
        dtype:'',
        detail:{},
        detailDialogVisible:false,
        dialogVisible:false,
        dtypes:{'main':'主险','additional':'附加险','special':'特别约定','deductible':'免赔条款'}
      }
    },
    mounted() {
      getInsuranceProductsAll().then(res => {
        if(res && res.status === 0 && res.data){
          this.products = res.data;
          if(this.pid && this.pid!=null){
            for(let p in this.products){
              if(this.products[p].id === this.pid){
                this.getProduct(this.products[p]);
              }
            }
          }
        }
      });
    },
    methods: {
      showProduct(item){
        this.$router.push('/inquiry/term?id='+item.id);
        this.getProduct(item);
      },
      getProduct(item){
        getInsuranceProductsById(item.id).then(res => {
          if(res && res.status === 0){
            this.product = item;
            this.productInfo = res.data;
            this.dialogVisible = true;
          }
        })
      },
      toTerms(id){
        this.$router.push('/inquiry/add?id='+id);
      },
      showDetail(dtype,id){
        this.dtype = dtype;
        switch(dtype){
          case 'main':
            insuranceMainTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'additional':
            insuranceAdditionalTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'special':
            insuranceSpecialTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'deductible':
            insuranceDeductibleTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          default:
            break;
        }
      }
    }
  }
</script>

<style scoped>
  .inquiry_term {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #fefefe;
    overflow-y: scroll;
  }
  .inquiry_box {
    position:absolute;
    width:94%;
    height:82vh;
    margin-bottom:4rem;
    margin-left:3%;
    margin-right:3%;
    overflow-y:scroll;
  }
  .inquiry_cate {
    font-size:.9rem;
    font-weight:bold;
    height:2.4rem;
    line-height:2.4rem;
    color:#03a7d5;
  }
  .inquiry_term_one {
    width:98%;
    margin:1vh 1%;
  }
  .inquiry_term_one_box {
    width:90%;
    margin:0 5%;
  }
  .inquiry_term_title {
    width:100%;
    margin-top:1vh;
    float:left;
    font-size:1.1rem;
    height:2rem;
    color:#555;
    line-height:2rem;
    font-weight:bold;
  }
  .inquiry_term_special {
    float:left;
    width:47%;
    margin-right:3%;
    margin-bottom:1vh;
    overflow-x: hidden;
    font-size:.75rem;
    color:#999;
    text-align:left;
  }
  .inquiry_term_grey {
    width:100%;
    float:left;
    height:4.2rem;
    border-radius:.3rem;
    margin-bottom:1vh;
    background-color:#f9f9f9;
  }
  .inquiry_term_grey_left {
    width:35%;
    margin-left:2%;
    float:left;
    height:4.2rem;
  }
  .inquiry_term_grey_right {
    width:63%;
    float:right;
    height:4.2rem;
    font-size:.8rem;
  }
  .inquiry_term_grey_left_amount {
    height:2.8rem;
    line-height:2.8rem;
    color: #e95500;
    font-size:1.1rem;
    font-weight:bold;
    width:100%;
    float:left;
    overflow-x: hidden;
  }
  .inquiry_term_grey_left_amount_title {
    height:1rem;
    line-height:1rem;
    font-size:.8rem;
    color:grey;
    width:100%;
    float:left;
    overflow: hidden;
  }
  .inquiry_term_grey_right_premium {
    width:100%;
    float:left;
    height:2.2rem;
    line-height:2.7rem;
    overflow: hidden;
  }
  .inquiry_term_grey_right_rate {
    width:100%;
    float:left;
    height:2.2rem;
    line-height:1.7rem;
    overflow: hidden;
  }
  .inquiry_term_grey_right_span {
    color:#666;
  }
  .inquiry_term_grey_right_point {
    font-weight:bold;
    color:orange;
  }
  .inquiry_term_detail_main {
    color:#409EFF;
  }
  .inquiry_term_detail_additional {
    color:#409EFF;
  }
  .inquiry_term_detail_special {
    color:#409EFF;
  }
  .inquiry_bottom {
    width:100%;
    position:fixed;
    bottom:0;
    height:4.2rem;
    line-height:3.2rem;
    border-top:1px #ddd dashed;
  }
</style>



// WEBPACK FOOTER //
// src/components/inquiry/term.vue